/**
 * Replaces various "milestone" stages to be more understandable for the end user.
 *
 * @param text {string}: Text to potentially replace.
 *
 * @return {string}: Replaced text -- either "Pre-Sold Deal" or the original string.
 */
const replaceStageName = (opp) => {
    var stageName = (opp && opp.StageName) ? opp.StageName : null;
    var soldDeal = (opp && opp.Sold_Deal_Date__c) ? opp.Sold_Deal_Date__c : null;

    if(stageName === 'Milestone 1' && !soldDeal){
        return 'Pre-Sold Deal';
    } else if(stageName === 'Milestone 1' || stageName === 'Milestone 2' || stageName === 'Milestone 3'){
        return 'Sold Deal'
    } else {
        return stageName;
    }
};

export default replaceStageName;
